(function() {
    if (customElements.get('base-call-out') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        :host {
          --call-out-bg: currentColor;
          --call-out-border-width: 1px;
          --call-out-padding: 1em;
          --call-out-margin: 1em;
          --call-out-opacity: .25;
          margin-bottom: var(--call-out-margin);
          border: var(--call-out-border-width) solid var(--call-out-bg);
          display: block;
        }
        :host(:empty) {
          display: none;
        }
        [part="background"] {
          position: relative;
          padding: var(--call-out-padding);
          min-height: 100%;
          box-sizing: border-box;
        }
        [part="background"]::before {
          content: "";
          position: absolute;
          inset: 0;
          z-index: 0;
          background: var(--call-out-bg);
          opacity: var(--call-out-opacity);
        }
        [part="foreground"] {
          position: relative;
          z-index: 1;
        }
        [part="foreground"] ::slotted(*:last-child) {
          margin-bottom: 0;
        }
        :host(:is([severity="error"],[severity="alert"])) {
          --call-out-bg: darkred;
        }
        :host([severity="warning"]) {
          --call-out-bg: orangered;
        }
        :host([severity="notice"]) {
          --call-out-bg: orange;
        }
        :host([severity="success"]) {
          --call-out-bg: green;
        }
        
        </style>
        <div part="background">
            <div part="foreground"><slot></slot></div>
        </div>
        `;
        customElements.define('base-call-out', class extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
            }
        });
    }
})();
